import { STATUS_BADGE_CLASSES, STATUS_LABELS, type ProjectStatus } from '../../lib/projectStatus';
import { Badge } from '../ui';

export function StatusBadge({ status }: { status: ProjectStatus }) {
  return <Badge className={STATUS_BADGE_CLASSES[status]}>{STATUS_LABELS[status]}</Badge>;
}
